import _ from '@lodash';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import useToast from '@fuse/hooks/useToast';
import Tooltip from '@material-ui/core/Tooltip';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import DeleteConfirmModal from 'helper/DeleteConfirm';
import ActivityAgGridListing from '@fuse/components/ActivitieLogs/activitiesAgGridListing';
import { openReportViewerDialog, setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import { openFormViewerDialog, setFromData } from '../store/formViewDialogReducer';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';


function ListView(props) {
	const table_name = "CATEGORY";
	const router = useRouter();
	const dispatch = useDispatch();
	const gridRef = useRef();
	const toast = useToast(dispatch);
	const [ windowHeight, setWindowHeight ]  = useState(window.innerHeight - 330);
	const [ categoryDetails, setCategoryDetails ] = useState({})
	const [ openDeleteDialog, setOpenDeleteDialog ] = useState(false);
	const [groupByArr, setGroupByArr] = useState([])
	const [tabValue, setTabValue] = useState(0)
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [logs,setLogs] = useState([]);
	const [filterApplied, setFilterApplied] = useState(false);
	const [loadingActivityLog,setLoadingActivityLog] = useState(false);
	const skipHeader = [
		"id", "platform_customer_id", "entity_external_platform_id",
		"category_type", "image", "created_at", "updated_at",
		"category_id", "models", "original_info",
		"no_of_assets_belongs_to_this_category",
	]
	const tableHeaders = [
		"category_name", "no_of_assets", "description", "source"
	]
	// const query_data = useSelector((state) => state.categoryApp.filterParamsReducer);
	// const filterModel = useSelector((state) => state.categoryApp.filterParamsReducer.filter);
	const query_data = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.quick_filter
  );
	const tab_value = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.tab_value
  );

	const handleClickOpen = () => {
		setOpenDeleteDialog(true);
	};

	const handleClose = () => {
		setOpenDeleteDialog(false);
	};

	function handelEdit(data){
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}



	function handelDeleteV2() {
		if(categoryDetails.id !== undefined) {
			axios.delete(`/category/delete/${categoryDetails.id}?category_type=hardware`).then((res)=>{
				if(res.status === 201){
					toast.error(res.data.message)
					handleClose()
				}else{
					toast.success(res.data.message)
					props.refresh()
					handleClose()
				}
			}).catch((err)=>{
				toast.error(err.data);
			})
		}
	}

	function handelOpenDialouge(data){
		handleClickOpen()
		setCategoryDetails(data)
	}

	// function handleDeleteDialogOpen(data){
	// 	handleClickOpen()
	// 	setCategoryDetails(data)
	// }

	const [isGridReady, setIsGridReady] = useState(0);
	const onGridReady = (params) => {	
		gridRef.current = params
		setIsGridReady(isGridReady+1)
		// props.endUsersAccounts.forEach((list) => {
			// for(let [fieldName, value] of Object.entries(list)){
			// 	if(fieldName === "description"){
			// 		list[fieldName] = <abbr style={{textDecoration: 'none'}} title={value}>{value}</abbr>
			// }
			// 	if(value === '') list[fieldName] = `No ${formatString(fieldName)}`
			// }
		// })
		if(router.query.report_name === undefined) {
			loadInitialState (params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		}else{
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}
	
	function onFilterChanged(event){
		const rows = event.api.getFilterModel();
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function getReport(event){
		const {report_name} = router.query;
		const table_name = "asset category";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event?.api.applyColumnState({ state: row_model });
		})
		.catch(err=>{
			console.log(err);
		})
	}

	function loadInitialState (params){
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
		.then(results=>{
			const { data } = results.data;
			if (data !== null) {
				const order = JSON.parse(data.order);
				const filter = JSON.parse(data.filter);
				gridRef.current.filterModelArr = filter
				params?.api.applyColumnState({ state: order });
				params?.api.setFilterModel(filter);
				if(filter && Object.keys(filter)?.length){
				  setFilterApplied(true)
				}
			  }
		})
		.catch(err=>{
			console.log(err);
		})
  }

	function saveView (rows, filter, filterModelArr=null){
		let payload = {}
		if(rows === 'N/A'){
			payload = {
				filter:  JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		}else{
			payload = {
				order:  JSON.stringify(rows),
				table_name
			}
		} 
		// const order = JSON.stringify(rows);
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
			console.log('view updated')
		})
		.catch(err=>{
			console.log(err);
		})
	}

	const onColumnMoved = (params) => {
		const rows = params.api.getColumnState();
		saveView(rows);
		dispatch(setrowGroupModel(rows))
	}

  function onColumnVisible(params){
		const rows = params.api.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
				saveView(params.api.getColumnState());
		}
	}
	function onSortChanged(params){
    if (router.query.report_name === undefined) {
      const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows));
      saveView(rows);
			dispatch(setrowGroupModel(rows));
    }
  }

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);

		if (router.query.report_name === undefined) {
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
			  dispatch(setrowGroupModel(rows));
			  saveView(rows);
			} else {
			  dispatch(setrowGroupModel(rows));
			}
		}
	}

	const onColumnPinned = (params) =>{
		const rows = params.api.getColumnState();
		if(router.query.report_name === undefined) {
			dispatch(setrowGroupModel(rows));
			saveView (rows);
		}
		
	}

	function onCellValueChanged(e){
		const payload = {
			category_id: e.data.id,
			category_name: e.data.category_name,
		}
		if(!payload.category_name){
			toast.error('Asset Category Name is required')
			props.refresh()
			return
		}
		axios.post(`/category/edit?category_type=hardware`, payload).then(response => {
			if(response.status === 201){
				toast.error(response.data.message)
				props.refresh()
			} else {
				toast.success('Asset Category updated Successfully.')
				props.refresh()
			}		  
		}).catch(err => {
			console.log('212=>',err);
			toast.error('Something went wrong!')
		})

	}

	const generateHeaderLabel = (header) => {
		if(header === 'category_name'){
			return 'Asset Category'
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

	function redirectToAssetProfile(event){
		if(event.value === 0){
      return
    }
		// localStorage.setItem('category_id',event.data.id)
		openInNewTab(`/assets-list?category_id=${event.data.id}`)
	}

	// useEffect(()=>{
	// 	gridRef?.current?.api?.setQuickFilter(
	// 		query_data.query
	// 	);
	// 	if(Object.keys(filterModel).length !== 0){
	// 		setTimeout(()=>{
	// 			gridRef.current.api.setFilterModel(filterModel);
	// 		},0)
	// 	}
	// },[query_data.query])
	useEffect(() => {
		// console.log('@@@@@@@@@@@@@@@@@@@@@', props.endUsersAccounts)
		return () => {
				dispatch(setQuickFilter(null))
		}
	}, [])

	useEffect(()=>{
		gridRef.current.api?.setQuickFilter(
			query_data
		);
	},[query_data])

	useEffect(()=>{
    setTabValue(tab_value)
  }, [tab_value])
	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	const handleChildClick = (value) => {
		setTabValue(value)
  };

	function formatLogs(data){
		return data.map((item)=>{
			return {
				id:item.id,
				action_id: `act${item.id}`,
				action_date_and_time: item.created_at,
				category_name: item?.category?.category_name || item.category_name,
				name: item.user_name,
				action: item.action_name,
				description: item.comment,
				previous_value: item.previous_data,
				current_value: item.current_data,
				field_name: item.action_field_name,
				user_role: item.user_role_name
			}
		})
	}
	
	function handleAddAssetCategory(){
		dispatch(openFormViewerDialog())
	}

	function getLogs(){
		setLoadingActivityLog(true)
		axios.get('/category/activities')
		.then(({data})=>{
			setLoadingActivityLog(false)
			setLogs(formatLogs(data.data.activities));
		})
		.catch(()=>{
			console.log('cannot fetch logs');
		})
	}
	useEffect(()=>{
		(tabValue === 1) && getLogs()
	},[tabValue])

	const handleAddReport = () => {
		dispatch(openReportViewerDialog())
	}

	return (	
		<>
		{(tabValue === 0) && <AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
				 groupByArrFromList ={ groupByArr }
				 tableName= "asset_category" logs={logs} displayTableName = "Asset Categories"
				 onClick={handleChildClick} onClickAddButton={handleAddAssetCategory}
				 addPermission = {props.createCategoryPermission}
				 onClickAddReportButton={handleAddReport}
				 key={isGridReady}
				 />
		}

			{(tabValue === 1) && (<ActivityAgGridListing module="asset_category" logs={logs} displayTableName = "Asset Categories"
				addPermission = {props.createCategoryPermission}
				loadingActivityLog={loadingActivityLog}
				/>)}

			{/* {(tabValue === 1) && (<ActivityAgGridListing module={'asset_category'} logs={logs} displayTableName = {'Asset Categories'}
				addPermission = {props.createCategoryPermission}
				loadingActivityLog={loadingActivityLog}
				/>)} */}
			{(tabValue === 0) && <div
				className="ag-theme-alpine" 
				style={{
					width: "100%",
					height:windowHeight+105,
					fontSize:'12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
                    theme="legacy"
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
                    headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}

					groupHeaderHeight={1}
					components={frameworkComponents}
					floatingFiltersHeight={40}

					// get filter model
					onFilterChanged={onFilterChanged}
					
					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}
					pagination
					defaultColDef={{
						// flex: 1,
						// minWidth: 100,
						enableRowGroup: true,
						sortable: true,
						resizable: true
					}}
					columnDefs={[{
						lockPosition: true,
						rowSelection: "single",
						width: 100,
						minWidth: 100,
						maxWidth: 100,
						suppressSizeToFit: true,
						headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
						className: "action_field",
						pinned: 'right',
						lockPinned: true,
						cellRenderer: ({ data }) => {
							if (data) {
								return (
									<>
										{props.updateCategoryPermission &&
											<Tooltip id="edit" title="Edit" placement="top">
												{/* <Icon 
													onClick={() => handelEdit(data)} 
													style={{
															color: '#1d2939',
															paddingBottom: '3px',
															paddingRight:'30px',
															fontSize:'15px',
															cursor:'pointer'
														}}
													>
														edit
													</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-pencil" onClick={() => handelEdit(data)} />
											</Tooltip>
										}
										{props.deleteategoryPermission &&
											<Tooltip id="delete" title="Delete" placement="top">
												{/* <Icon 
													onClick={() => handelOpenDialouge(data)} 
													style={{
														color: '#1d2939',
														paddingBottom: '3px',
														paddingRight:'30px',
														fontSize:'15px',
														cursor:'pointer'
													}}
												>
													delete
												</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-trash" onClick={() => handelOpenDialouge(data)} />
											</Tooltip>
										}
									</>
								)
							}
							return (<></>)
							
						},
					},
						...tableHeaders.filter((item) => !skipHeader.includes(item)).map(header => {
							const baseCol = {
								key: header,
								field: header,
								suppressSizeToFit: true,
								headerName: generateHeaderLabel(header),
								sortable: true,
								filter: "agTextColumnFilter",
								flex: 1,
								minWidth: 200,
								headerComponent: (prop) => (CustomFilter(prop, header, gridRef))
							}
							if (header === 'no_of_assets') {
								return {
									...baseCol,
									editable: false,
									onCellValueChanged,
									cellRenderer: (event) => {
										if (event.value) {
											return (<a
												style={{
													height: '10px',
													width: '10px',
													color: 'black',
													cursor: 'pointer',
													marginTop: '2px',
													borderRadius: '50%',
													// display: 'inline-block',
													display: 'flex',
													alignItems: 'center',
													gap: '10px'
												}}
												onClick={() => redirectToAssetProfile(event)}
												variant="subtitle1"
											>
												<><span>{event.value}</span></>
											</a>)
										}
										return <span>{event.value}</span>
									}
								}
							}
							if (header === 'description') {
								return {
									...baseCol,
									editable: false,
									onCellValueChanged,
									cellRenderer: (event) => {
										return (
											<abbr style={{ textDecoration: 'none' }} title={event.value}>{event.value}</abbr>
										)
									}
								}
							}
							if (header === 'source') {
								return {
									...baseCol
								}
							}
							return {
								...baseCol,
								editable: props.updateCategoryPermission,
								onCellValueChanged,
							}
						})
					]}
				 />
				{/* <DeleteModelDialog
					openDeleteDialog={openDeleteDialog}
					categoryDetails={categoryDetails}
					handelDelete={handelDelete}
					handleClose={handleClose}
				/> */}
				{
					openDeleteDialog && 
					<DeleteConfirmModal
						openAlerModal={openDeleteDialog}
						module="Custom Report"
						handleCloseAlertModal={handleClose} 
						handleAlertModal={handelDeleteV2}
					/>
				}
			</div>}	
		</>		
	);
}

export default ListView

